<template>
  <div class="chexiao">
    <el-dialog :visible.sync="show">
      <div class="content">
        <div class="title">请输入验证码</div>
        <div class="desc">
          撤销合同《{{ subject }}》，撤销后不可恢复。需要验证当前手机号

          {{ user.phone }}验证码
        </div>
        <el-input v-model="verifyCode" placeholder="请输入验证码" style="margin-top: 4px">
          <template slot="suffix">
            <el-button type="text" @click="getCode">{{ secondrender }}</el-button>
          </template>
        </el-input>
        <div class="btns">
          <el-button @click="show = false" size="mini">取 消</el-button>
          <el-button type="primary" @click="submit" size="mini">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userinfo from "@/mixins/userinfo";
import second from "@/mixins/second";
export default {
  mixins: [userinfo, second],
  components: {},
  data() {
    return {
      show: false,
      subject: "",
      uuid: "",
      verifyCode: "",
    };
  },
  created() {},
  computed: {},
  methods: {
    onShow({ uuid, subject }) {
      this.uuid = uuid;
      this.subject = subject;
      this.show = true;
    },
    async deleteContract() {
      const { uuid, verifyCode } = this;
      const { status, info } = await this.$api.deleteContract({ uuid, verifyCode });
      if (status == 200) {
        this.$message({
          type: "success",
          message: info,
        });
        this.$emit("success");
        this.show = false;
      } else {
        this.$message({
          type: "error",
          message: info,
        });
      }
    },
    submit() {

      if (!this.verifyCode) {
        this.$message({
          type: "error",
          message: "请输入验证码",
        });
        return;
      }
      this.deleteContract();
    },
    async getCode() {
      const { status, info } = await this.$api.postRevokeContract({ phone: this.user.phone });
      if (status != 200) {
        this.$message({
          type: "error",
          message: info,
        });
        return;
      }
      this.$message({
        type: "success",
        message: info,
      });
      this.secondrun();
    },
  },
};
</script>

<style scoped lang="scss">
.chexiao {
  .content {
    @include dialogDefStyle;
    &::v-deep {
      @include inputStyle;
    }
    .desc {
      font-size: 14px;
      font-weight: 350;
      line-height: 22px;
      color: #666666;
    }
  }
}
</style>
